import { render } from "./SignupReferralCode.vue?vue&type=template&id=117932cf&ts=true"
import script from "./SignupReferralCode.vue?vue&type=script&lang=ts"
export * from "./SignupReferralCode.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__